import { ScreenId } from "@/js/value-objects/screen-id";

class FacilityType {
  constructor(isSchool) {
    this.isSchool = isSchool;
    this.pathPrefix = isSchool ? "school" : "facility";
    this.titlePrefix = isSchool ? "学校" : "要配慮者施設";
  }

  title(suffix) {
    return `${this.titlePrefix}${suffix}`;
  }

  groupPath() {
    return `/${this.pathPrefix}-qr-code`;
  }

  groupScreenId() {
    if (this.isSchool) {
      return ScreenId.SF0604;
    }
    return ScreenId.SF0601;
  }

  issuePath(groupId, type) {
    return `/${this.pathPrefix}-qr-code/issue?group_id=${groupId}&type=${type}`;
  }

  issueScreenId() {
    if (this.isSchool) {
      return ScreenId.SF0606;
    }
    return ScreenId.SF0603;
  }

  registerPath(groupId, type) {
    return `/${this.pathPrefix}-qr-code/register?group_id=${groupId}&type=${type}`;
  }
}

const install = Vue => {
  Vue.prototype.$facilityType = {
    factory(isSchool) {
      return new FacilityType(isSchool);
    }
  };
};
export default {
  install
};
